export default {"src":"/komodo/_next/static/media/dgb.7a28f20b.svg","height":30,"width":92,"blurWidth":0,"blurHeight":0};